// $Id$
var crmInteraction = {};
document.addEventListener('lytetabopen',function(event){//eslint-disable-line @zoho/zstandard/no-body-events
	var targetElement = event.target;
	crmInteraction.addLyteTabInteraction(targetElement);
})

document.addEventListener('checkboxchange',function(event){//eslint-disable-line @zoho/zstandard/no-body-events
	var targetElement = event.target;
	var onBtn = targetElement.querySelector(".on-btn"); // No i18n
	if(onBtn !== null){
		onBtn.addEventListener("animationend", function(){
			targetElement.classList.remove("lyteCboxChecked"); // No i18n
			targetElement.classList.remove("lyteCboxUnchecked"); // No i18n
		})
	}
})

document.addEventListener('beforeshow',function(event){//eslint-disable-line @zoho/zstandard/no-body-events
	var targetElement = event.target;
	var targetElementName = event.target.tagName;
	//Comment for Crux changes by karthipan
	// if(targetElementName === "LYTE-HOVERCARD" && event.detail.originalEvent && event.detail.originalEvent.type === "click"){ //NO I18N
	// 	$L(targetElement)[0].ltProp("popoverWrapperClass", "crmHovercardWithCallout"); //NO I18N
	// }else  
	if(targetElementName === "LYTE-DRODPOWN"){ //NO I18N
		var isSmallDropdown = $L(targetElement).hasClass("crmSmallDropdown"); //NO I18N
		var hasClosestDropdown = $L(targetElement).closest(".crmSmallDropdown").length; //NO I18N
		if(isSmallDropdown || hasClosestDropdown > 0){
			var dropboxElement = targetElement.getDropBox()
			dropboxElement.classList.add("crmSmallDropbox"); //NO I18N
		}
	}
})

document.addEventListener("lyteAlertOpened", function(event){//eslint-disable-line @zoho/zstandard/no-body-events
	var alertPopupElm = event.target;
	var alertWrapperElm = $L(alertPopupElm.closest(".alertWrapper"));// No i18n
	
	if(alertPopupElm.offsetTop === 0 && alertWrapperElm){
		alertWrapperElm.addClass("crmAlertRemoveBdrRadius"); //NO I18N
	}else{
		alertWrapperElm.removeClass("crmAlertRemoveBdrRadius"); //NO I18N
	}
})

document.addEventListener("lyteAlertBeforeOpened", function(event){//eslint-disable-line @zoho/zstandard/no-body-events
	var alertPopupElm = event.target;
	var alertWrapperElm = $L(alertPopupElm.closest(".alertWrapper"));// No i18n
	
	var hasStatusIconElm = $L(alertPopupElm).find(".lyteStatusIcon").length;
	var hasClassCxAlertWrapper = alertWrapperElm.hasClass("cxAlertWrapper"); //NO I18N
	if(hasStatusIconElm > 0 && hasClassCxAlertWrapper){
		alertWrapperElm.addClass("crmHasAlertStatusIcon"); //NO I18N
	}else{
		alertWrapperElm.removeClass("crmHasAlertStatusIcon"); //NO I18N
	}
	
	var templateElemet = event.target._callee;
	if(templateElemet.ltProp("top") === "0" || templateElemet.ltProp("top") === "0px"){
		alertWrapperElm.addClass("crmAlertRemoveBdrRadius"); //NO I18N
	} else{
		alertWrapperElm.removeClass("crmAlertRemoveBdrRadius"); //NO I18N
	}
})

document.addEventListener("lyteModalOpened", function(event){//eslint-disable-line @zoho/zstandard/no-body-events
	var targetElement = event.target; 
	if($L(targetElement).find("lyte-modal-content").length > 0 && $L(targetElement).find("lyte-modal-header").length > 0 && $L(targetElement).find("lyte-modal-footer").length > 0){
		crmInteraction.modalShadow(targetElement);
	}
})

crmInteraction.modalShadow = function(targetElement){
	var content = $L(targetElement).find('lyte-modal-content'); //NO I18N
    var contentScrollTop = content.scrollTop();
    var footer = $L(targetElement).find("lyte-modal-footer"); //NO I18N
    var scrollpos = parseInt(contentScrollTop + content.innerHeight()) + 10;
    if(scrollpos < content[0].scrollHeight) {
        footer.addClass("box-sh"); //NO I18N
    }else{
		footer.removeClass("box-sh"); //NO I18N
	}
    content.off('scroll'); //NO I18N
    content.on('scroll', function(){ //NO I18N
    	var content = $L(targetElement).find('lyte-modal-content'); //NO I18N
        var contentScrollTop = content.scrollTop();
        var footer = $L(targetElement).find("lyte-modal-footer"); //NO I18N
        var header = $L(targetElement).find("lyte-modal-header"); //NO I18N

        var scrollpos = parseInt(contentScrollTop + content.innerHeight()) + 10;
        if(scrollpos >= content[0].scrollHeight) {
            footer.removeClass("box-sh"); //NO I18N
        }
        else{
            footer.addClass("box-sh"); //NO I18N
        }

		if(contentScrollTop === 0) {
			header.removeClass("box-sh"); //NO I18N
		}
		else{
			header.addClass("box-sh"); //NO I18N
		}
    });
}

document.addEventListener("lyteModalClosed", function(){//eslint-disable-line @zoho/zstandard/no-body-events
	var targetElement = event.target;
	var content = $L(targetElement).find('lyte-modal-content'); //NO I18N
	content.off('scroll'); //NO I18N
});

crmInteraction.addLyteTabInteraction = function(targetElement){
	if(targetElement.classList.contains("lyteOuterTab") || targetElement.classList.contains("lyteInnerTab")){
		var activeTab = targetElement.querySelector(".lyteTabActive"); //No I18N
		var activeTabWidth = activeTab.clientWidth;
		var activeTabLeft = activeTab.offsetLeft;
		
		var lyteTabHead = activeTab.closest("lyte-tab-head");//No I18N
		var lyteOuterActiveTab = lyteTabHead.querySelector("#lyteOuterActiveTab");//No I18N
		if(lyteOuterActiveTab === null){
			var spanElm = document.createElement("span");
			var className = "";
			if(targetElement.classList.contains("lyteOuterTab")){
				className = "lyteOuterActiveTab";//No I18N
			}else if(targetElement.classList.contains("lyteInnerTab")){//No I18N
				className = "lyteInnerActiveTab";//No I18N
			}
			spanElm.setAttribute("class", className);
			spanElm.setAttribute("id", "lyteOuterActiveTab");
			
			lyteTabHead.append(spanElm);
			lyteOuterActiveTab = spanElm;
		}
		
		lyteOuterActiveTab.style.cssText = "width:" +activeTabWidth+"px; left: " +activeTabLeft+"px";//No I18N
	}
}


crmInteraction.bindScrollShadow = function(elm){
	var content = null;
	if(typeof elm === "string"){
		content = $("#"+elm);
	}else if(typeof elm === "object"){//NO I18N
		content = elm;
	}
	
	content.off('scroll'); //NO I18N
	content.on('scroll', function(ev){ //NO I18N
		var content = $(ev.target);
		var contentScrollTop = content.scrollTop();

		var scrollpos = parseInt(contentScrollTop + content.innerHeight())+10;
		if(scrollpos >= content[0].scrollHeight) {
			content.removeClass("box-sh-footer"); //NO I18N
		}
		else{
			content.addClass("box-sh-footer"); //NO I18N
		}

		if(contentScrollTop === 0) {
			content.removeClass("box-sh-header"); //NO I18N
		}
		else{
			content.addClass("box-sh-header"); //NO I18N
		}
	});
}

crmInteraction.floatCompWithPopup = function(elem,action,compType){
	compType = compType ? compType : "LYTE" //NO I18N
	if(action === "open"){
		crmui.prevoisElement.push(elem)
	}else if(action === "close"){ //NO I18N
		crmui.removePreviousElements(elem,compType)
	}
}